<template lang="pug">
    div.work-order-maintenance-detail.content-common-margin(
        v-if="getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderDetail')"
        v-loading="loading"
        element-loading-text="玩命加载中"
    )
        header-title(
            title=""
            backRouteName="MaintenanceWorkOrderIndex"
        )
            div(
                slot="remark-desc"
                class="work-order-maintenance-detail-tab"
            )
                count-tabs(
                    v-model="activeName"
                    :showCount="false"
                    :isDetail="true"
                    :options="tabOptions"
                )
        div.detail-container(v-show="activeName === 'detail'")
            .left-content
                customer-info(:detail-data="detailData" @updateInfo="getWorkOrderDetail($route.query.id)")
                order-info(:detail-data="detailData" @updateInfo="getWorkOrderDetail($route.query.id)")
                customer-comment(:detail-data="detailData")
            .right-content
                order-step-maintain(:detail-data="detailData" @completeData="handleComplete")
        div(
            v-show="activeName === 'history'"
            v-loading="hisLoading"
            element-loading-text="玩命加载中"
            class="work-order-maintenance-detail-history"
        )
            el-table.table(
                border
                :header-cell-style="{'background': '#F9F9F9','padding': '3px 0'}"
                :data="historyData"
            )
                el-table-column(
                    align="center"
                    label="操作类型"
                    prop="type"
                )
                el-table-column(
                    align="center"
                    label="操作详情"
                    prop="content"
                )
                el-table-column(
                    align="center"
                    label="操作人"
                    prop="name"
                )
                el-table-column(
                    align="center"
                    label="操作时间"
                    prop="time"
                )
                    template(
                        slot-scope="scope"
                    )
                        span {{ scope.row.time | dateFormat }}
            el-pagination.pagination(
                layout="sizes, prev, pager, next, jumper"
                :total="historyTotal"
                :page-sizes="[10, 30, 50]"
                :page-size="pageSize"
                :current-page.sync="pageNum"
                @current-change="currentChangeHandle"
                @size-change="sizeChangeHandle"
            )
        div.bottom-btns-container(v-if="canCancel || canResolve || canAllot")
            el-button(
                round
                :disabled="!getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderCancel')"
                @click="handleCancel(detailData)"
                v-if="canCancel"
            ) 取消工单
            el-button(
                round
                type="primary"
                :disabled="!getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderOperate')"
                @click="handleResolve(detailData)"
                v-if="canResolve"
            ) 去处理
            el-button(
                round
                type="primary"
                :disabled="!getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderDistribution')"
                @click="handleDistribution(detailData)"
                v-if="canAllot"
            ) 分配顾问
        cancel-order(
            v-if="cancelData.show"
            :dialogData="cancelData"
            :order-type="'REPAIR'"
            @refresh="refreshHandle"
        )
        resolve-order-maintain(
            v-if="resolveData.show"
            :dialogData="resolveData"
            @refresh="refreshHandle"
        )
        complete-order-maintain(
            v-if="completeData.show"
            :dialogData="completeData"
            @refresh="refreshHandle"
        )
        distribute-order(
            v-if="distributionData.show"
            :dialogData="distributionData"
            @update="refreshHandle"
        )
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { handleParameter } from '@/filters';
import HeaderTitle from '@/components/HeaderTitle.vue';
import CountTabs from '@/components/CountTabs.vue';
import { workOrderApis } from '@/api';
import CustomerInfo from '@/components/workOrder/CustomerInfo.vue';
import OrderInfo from '@/components/workOrder/OrderInfo.vue';
import CustomerComment from '@/components/workOrder/CustomerComment.vue';
import OrderStepMaintain from '@/components/workOrder/OrderStepMaintain.vue';
import ResolveOrderMaintain from '@/components/workOrder/ResolveOrderMaintain.vue';
import CompleteOrderMaintain from '@/components/workOrder/CompleteOrderMaintain.vue';
import CancelOrder from '@/components/workOrder/CancelOrder.vue';
import DistributeOrder from '@/components/workOrder/DistributeOrder.vue';

export default {
    name: 'MaintenanceWorkOrderDetail',
    components: {
        HeaderTitle,
        CountTabs,
        CustomerInfo,
        OrderInfo,
        CustomerComment,
        OrderStepMaintain,
        ResolveOrderMaintain,
        CompleteOrderMaintain,
        CancelOrder,
        DistributeOrder,
    },
    data() {
        return {
            activeName: 'detail',
            tabOptions: [
                {
                    label: '工单详情',
                    name: 'detail',
                },
                {
                    label: '操作记录',
                    name: 'history',
                },
            ],
            hisLoading: true,
            historyData: [],
            historyTotal: 0,
            pageNum: 1,
            pageSize: 10,
            loading: false,
            detailData: {},
            cancelData: {
                show: false,
                id: '',
            },
            resolveData: {
                show: false,
                id: '',
            },
            completeData: {
                show: false,
                id: '',
            },
            distributionData: {
                show: false,
                data: {},
            },
        };
    },
    created() {
    },
    computed: {
        ...mapGetters('user', [
            'getAuthority',
        ]),
        ...mapState('user', [
            'userInfo',
        ]),
        isStore() {
            return this.userInfo.orgType === 'STORE';
        },
        canCancel() {
            return (['CHECKING'].includes(this.detailData.orderStatus)) && this.isStore && this.getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderCancel', true);
        },
        canResolve() {
            return (['IN_DELIVERY', 'CHECKING', 'UNDER_CONSTRUCTION'].includes(this.detailData.orderStatus)) && this.isStore && this.getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderOperate', true);
        },
        canAllot() {
            return (['IN_DELIVERY', 'CHECKING', 'UNDER_CONSTRUCTION'].includes(this.detailData.orderStatus)) && this.isStore && this.getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderDistribution', true);
        },
    },
    watch: {
        activeName(val) {
            if (val === 'history') {
                this.getHistory();
            }
        },
    },
    methods: {
        currentChangeHandle(pageNum) {
            this.pageNum = pageNum;
            this.getHistory();
        },
        sizeChangeHandle(pageSize) {
            this.pageSize = pageSize;
            this.pageNum = 1;
            this.getHistory();
        },
        refreshHandle() {
            this.activeName = 'detail';
            this.insetParams();
        },
        insetParams() {
            if (!this.getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderDetail')) return;
            this.getWorkOrderDetail(this.$route.query.id);
            this.getHistory();
        },
        async getHistory() {
            if (!this.getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderDetail')) return;
            this.hisLoading = true;
            try {
                this.historyData = [];
                const { data } = await workOrderApis.getWorkOrderRecords(this.$route.query.id, {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                });
                this.historyData = data.list || [];
                this.historyTotal = data.total || 0;
            } catch (error) {
                throw new Error(error);
            } finally {
                this.hisLoading = false;
            }
        },
        async getWorkOrderDetail(id) {
            if (!this.getAuthority('MaintenanceWorkOrder', 'MaintenanceWorkOrderDetail')) return;
            try {
                this.loading = true;
                const { data } = await workOrderApis.getWorkOrderDetail(id);
                this.detailData = data;
            } catch (error) {
                this.detailData = {};
                throw new Error(error);
            } finally {
                this.loading = false;
            }
        },
        handleCancel(row) {
            this.cancelData = {
                show: true,
                id: row.id,
            };
        },
        handleResolve(row) {
            this.resolveData = {
                show: true,
                id: row.id,
            };
        },
        handleDistribution(row) {
            this.distributionData = {
                show: true,
                data: row,
            };
        },
        handleComplete(row) {
            this.completeData = {
                show: true,
                id: this.detailData.id,
                stepName: row.key,
            };
        },
        handleParameterFun() {
            handleParameter({
                trackKey: 'workorderservice_techdetail_maintenance_popup',
                attr: {
                    shop_id: this.userInfo.lastLoginOrgId,
                    account_type: this.userInfo.orgType,
                    xyt_id: this.userInfo.id,
                    workorder_id: this.$route.query.id,
                },
            });
        },
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            const myVm = vm;
            // 从其他页面进入刷新
            const fromName = [
                'MaintenanceWorkOrderIndex',
                'MaintainRemindDetail',
                'AppointmentOrderDetail',
                'VehicleListDetail',
                'CustomerListDetail',
            ];
            if (from.name === null || fromName.some(v => v === from.name)) {
                myVm.refreshHandle();
                myVm.handleParameterFun();
            }
        });
    },
};
</script>

<style lang="scss" scoped>
    .work-order-maintenance-detail {
        position: relative;
        height: calc(100% - 50px);
        &-tab {
            .count-tabs {
                display: flex;
                justify-content: center;
            }
        }
        &-history {
            background-color: #fff;
            padding: 20px 93px 25px 47px;
            margin-bottom: 60px;
            .pagination {
                display: flex;
                justify-content: center;
                margin-top: 28px;
            }
            .content {
                display: flex;
                flex-direction: row;
                justify-content: center;
                line-height: 21px;
                .see-content{
                    white-space: pre-wrap;
                    font-size: 12px;
                }
                .button {
                    margin-left: 10px;
                    padding: 0;
                }
            }
        }
        .detail-container {
            width: 100%;
            height: 100%;
            display: flex;
            .left-content {
                flex: 1;
                max-width: 50%;
                height: 100%;
                border-right: 1px solid #EEEEEE;
            }
            .right-content {
                flex: 1;
                height: calc(100vh - 162px);
                background-color: #fff;
                overflow-y: auto;
                padding-bottom: 50px;
            }
        }
    }
</style>
<style lang="scss">
    .work-order-maintenance-detail {
        .el-button--primary.is-round {
            border-radius: 18px;
        }
    }
</style>
